import React, { useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDictionary } from 'bdvp-common/src/hooks/config';

import COLORS from '@mlb/react-patterns/style/universal.color';

import { Tracking } from 'bdvp-tracking';
import { useDidUpdate } from 'bdvp-common/src/hooks';

import FieldLabel from './FieldLabel';

const Input = styled.input`
    height: 64px;
    width: 100%;
    border-radius: 6px;
    background: ${COLORS.mlbGrey6};
    border: 1px solid ${({ error }) => error ? '#C90024' : COLORS.mlbGrey6};
    padding: 20px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.mlbWhite};
    ${({ error }) => error && 'outline: none;'}
`;

const ErrorMsg = styled.div`
    color: #C90024;
    font-size: 15px;
    font-weight: 600;
`;

const TitleField = (props) => {

    const {
        formState,
        handleChange,
        isLastNode,
        lastModalNode,
    } = props;

    const {
        reel_title: reelTitle = 'Reel Title',
    } = useDictionary();

    const inputRef = useRef(null);

    useDidUpdate(() => {

        if (formState.error) {

            inputRef.current.focus();

        }

    }, [formState.error]);

    return (
        <>
            <FieldLabel htmlFor={'Reel Title'}>{reelTitle}</FieldLabel>
            <Input
                type={'text'}
                id={'Reel Title'}
                name={'reelTitle'}
                value={formState.reelTitle}
                onChange={handleChange}
                error={formState.error}
                required
                autoComplete={'off'}
                ref={isLastNode ? lastModalNode : inputRef}
                onClick={() => {

                    Tracking.trackReelCreationFormTitleClick();

                }}
            />
            {formState.error && <ErrorMsg>{formState.error}</ErrorMsg>}
        </>
    );

};

TitleField.propTypes = {
    formState: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    isLastNode: PropTypes.bool.isRequired,
    lastModalNode: PropTypes.object.isRequired,
};

export default TitleField;
